import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isBetween from 'dayjs/plugin/isBetween';
import type { Dayjs, OpUnitType } from 'dayjs';
export { Dayjs };

dayjs.extend(utc);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);

export default dayjs;

// 计算周期开始时间
export const startOf = (value: Dayjs, type: OpUnitType) => dayjs(value).startOf(type).format('YYYY-MM-DD HH:mm:ss');

// 计算周期结束时间
export const endOf = (value: Dayjs, type: OpUnitType) => dayjs(value).endOf(type).format('YYYY-MM-DD HH:mm:ss');

// 获取年月日格式
export const defaultFormat = (value: Dayjs) => dayjs(value).format('YYYY-MM-DD');

// 获取年月格式
export const monthFormat = (value: Dayjs) => dayjs(value).format('YYYY-MM');

// 格式化获取时分
export const formatHHmm = (value: string) => dayjs(value, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');

// 用户本地时区
export const localeUTC = new Date().getTimezoneOffset() / -60;

// TZ 时区
export const localTimezone = dayjs.tz.guess();

// 根据时区转换时间
export function convertTimezone(time: string, zone: string, type = 'YYYY-MM-DD HH:mm:ss') {
    return dayjs(time).tz(zone).format(type);
}
